import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getVideos, removeVideo } from 'slice/videoSlice';
import AdminTable from 'common/AdminTable';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

const List = () => {
    const dispatch = useDispatch();
    const { data: videos, loading } = useSelector((state) => state.video);

    useEffect(() => {
        dispatch(getVideos());
    }, [dispatch]);

    const getFileUrl = (file) => {
        const backend = process.env.REACT_APP_BACKEND || 'http://localhost:8001/';
        const base = backend.endsWith('/') ? backend : backend + '/';
        return `${base}uploads/${file.trim()}`;
    };

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#e67e22',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeVideo(id));
            }
        });
    };

    const tableHeaders = [
        { Header: 'ID', accessor: 'id' },
        { Header: 'Video Name', accessor: 'videoName' },
        {
            Header: 'Video Preview',
            accessor: 'videoPath',
            Cell: ({ row }) => (
                <video width="120" height="80" controls muted style={{ borderRadius: '8px' }}>
                    <source src={getFileUrl(row.original.videoPath)} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            ),
        },
        { Header: 'Created At', accessor: 'createdAt', Cell: ({ value }) => new Date(value).toLocaleDateString() },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <>
                    <button className="btn removebtn mx-1" onClick={() => handleDelete(row.original.id)}>
                        Remove
                    </button>
                    <Link to={`/khajuraho/videos/update/${row.original.id}`} className="btn editbtn mx-1">
                        Edit
                    </Link>
                </>
            ),
        },
    ];

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4 d-flex justify-content-between align-items-center">
                <h4 className="text-white font-weight-bold">Promotional Videos</h4>
                <Link to="/khajuraho/videos/add" className="btn btn-light btn-sm font-weight-bold">
                    Add Video
                </Link>
            </div>
            <div className="mt-4">
                {loading ? (
                    <div className="text-center text-white">Loading...</div>
                ) : (
                    videos?.length > 0 ? (
                        <AdminTable tableHeaders={tableHeaders} tableData={videos} />
                    ) : (
                        <div className="text-center text-white">No videos found.</div>
                    )
                )}
            </div>
        </div>
    );
};

export default List;
